<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { formatDate } from '@utils/date'
import Button from '@components/global/button.vue'
import ArrowButton from '@components/global/arrow-button.vue'
import MerchCard from '@components/global/merch/card.vue'

defineProps(['collection'])

const swiperRef = ref(null)

const breakpoints = ref({
	0: {
		slidesPerView: 1,
		spaceBetween: 20,
	},
	640: {
		slidesPerView: 2,
		spaceBetween: 20,
	},
	1024: {
		slidesPerView: 3,
		spaceBetween: 20,
	},
	1280: {
		slidesPerView: 4,
		spaceBetween: 20,
	},
})

function goPrev() {
	if (swiperRef.value && swiperRef.value.$el && swiperRef.value.$el.swiper) {
		swiperRef.value.$el.swiper.slidePrev()
	}
}

function goNext() {
	if (swiperRef.value && swiperRef.value.$el && swiperRef.value.$el.swiper) {
		swiperRef.value.$el.swiper.slideNext()
	}
}
</script>

<template>
	<section class="container flex flex-col gap-10">
		<div class="flex h-full w-full items-center justify-between gap-4">
			<div v-if="collection" class="flex items-center gap-2 bg-bg-dark font-medium uppercase text-sf-purple-base">
				<h2 class="break-words font-heading text-h2">
					{{ collection.title }}
				</h2>
				<div class="hidden md:block">
					<Button :to="{ name: 'collection', params: { slug: collection.slug } }" class="text-body-sm">see collection</Button>
				</div>
			</div>
			<div class="hidden items-center gap-4 sm:flex">
				<Button @click="goPrev" class="group rotate-180">
					<ArrowButton />
				</Button>
				<Button @click="goNext" class="group">
					<ArrowButton />
				</Button>
			</div>
		</div>

		<Swiper ref="swiperRef" :breakpoints="breakpoints" class="w-full" v-if="collection">
			<SwiperSlide v-for="item in collection.products" :key="item.id" class="w-full">
				<MerchCard :item="item" />
			</SwiperSlide>
		</Swiper>
	</section>
</template>
